import { registerAppLoadingScreenDismiss } from "@dust-tt/front/lib/app_loading_screen";
import { createContext, useCallback, useContext, useEffect, useRef } from "react";

const AppReadyContext = createContext<() => void>(() => {});

function hideLoadingScreen() {
  const loading = document.getElementById("loading");
  if (!loading || loading.classList.contains("hidden")) {
    return;
  }

  loading.classList.add("hidden");
}

export function useAppReadyContext() {
  return useContext(AppReadyContext);
}

export function AppReadyProvider({ children }: { children: React.ReactNode }) {
  const loadingHiddenRef = useRef(false);

  const handleAppReady = useCallback(() => {
    if (loadingHiddenRef.current) {
      return;
    }
    loadingHiddenRef.current = true;
    hideLoadingScreen();
  }, []);

  useEffect(() => {
    registerAppLoadingScreenDismiss(handleAppReady);
    return () => registerAppLoadingScreenDismiss(null);
  }, [handleAppReady]);

  return (
    <AppReadyContext.Provider value={handleAppReady}>
      {children}
    </AppReadyContext.Provider>
  );
}
